import { render, staticRenderFns } from "./LegalText.vue?vue&type=template&id=7150eca7&scoped=true&"
import script from "./LegalText.vue?vue&type=script&lang=js&"
export * from "./LegalText.vue?vue&type=script&lang=js&"
import style0 from "./LegalText.vue?vue&type=style&index=0&id=7150eca7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7150eca7",
  null
  
)

export default component.exports